import styled from "@emotion/styled";

export type FullPageLoaderSpinnerProps = {
  className?: string;
};

const segments = Array.from({ length: 12 }, (_, index) => index);

/* Exact compiled output of the pre-migration Tailwind utilities. */

const SpinnerShell = styled("span", {
  label: "AgenticFullPageLoader-spinner"
})({
  position: "relative",
  marginBottom: "1.75rem",
  display: "block",
  width: "3.5rem",
  height: "3.5rem",
  WebkitUserSelect: "none",
  MozUserSelect: "none",
  userSelect: "none"
});

const SpinnerSegment = styled("span", {
  label: "AgenticFullPageLoader-spinnerSegment"
})({
  position: "absolute",
  left: "50%",
  top: 0,
  height: "10px",
  width: "5px",
  transformOrigin: "50% 28px",
  borderRadius: "var(--bfrs-radius-pill)",
  "--tw-bg-opacity": "1",
  backgroundColor: "hsl(var(--bfrs-color-primary-bright) / var(--tw-bg-opacity, 1))",
  opacity: ".2",
  "@keyframes bfrs-bfrs-loader-segment": {
    "0%,12%": { opacity: 1, backgroundColor: "hsl(var(--bfrs-color-primary-bright))" },
    "24%": { opacity: ".7", backgroundColor: "hsl(var(--bfrs-color-primary))" },
    "52%,to": { opacity: ".16", backgroundColor: "hsl(var(--bfrs-color-success-soft))" }
  },
  animation: "bfrs-bfrs-loader-segment .96s linear infinite"
});

export function FullPageLoaderSpinner({ className }: FullPageLoaderSpinnerProps) {
  return (
    <SpinnerShell className={className} aria-hidden="true">
      {segments.map((segment) => (
        <SpinnerSegment
          key={segment}
          style={{
            transform: `translateX(-50%) rotate(${segment * 30}deg)`,
            animationDelay: `${segment * -80}ms`
          }}
        />
      ))}
    </SpinnerShell>
  );
}
